module.exports = __webpack_public_path__ + "img/ArrestedDevops.91322060.png";